import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { MenuItem, Select } from '@mui/material';

import { EllipsisIcon } from '@/common/icons/EllipsisIcon';
import { Purchase } from '../Types';

const useStyles: any = makeStyles(() => ({
  root: {
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    lineHeight: 1,
    color: '#999',
    transform: 'translateY(-12px)',
    rotate: '90deg',
    '& fieldset': {
      border: 'none'
    },
    '& :hover': {
      backgroundColor: 'transparent'
    }
  },
  menuItem: {
    fontWeight: 400,
    '& svg': {
      marginLeft: 4,
      marginRight: 16
    }
  },
  actionMenu: {
    padding: 0,
    '& .MuiSelect-icon': {
      color: '#999'
    }
  },
  icon: {
    pointerEvents: 'none',
    position: 'absolute',
    right: '10px'
  }
}));

export enum RECEIPT_ACTIONS {
  VIEW = 'VIEW',
  EMAIL = 'EMAIL',
  REFUND = 'REFUND'
}

export interface ReceiptActionMenuProps {
  purchaseId: number;
  actionCallback: (
    purchaseId: number,
    action: keyof typeof RECEIPT_ACTIONS
  ) => void;
}

const ReceiptActionMenu = (props: ReceiptActionMenuProps) => {
  const { purchaseId, actionCallback } = props;
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Select
        className={classes.actionMenu}
        IconComponent={() => (
          <EllipsisIcon className={classes.icon} color={'#328cc0'} />
        )}
        value={0}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        title={'View, Email or Refund'}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '4px'
            }
          }
        }}
      >
        <MenuItem
          className={classes.menuItem}
          key={1}
          onClick={() => {
            actionCallback(purchaseId, RECEIPT_ACTIONS.VIEW);
            setOpen(false);
          }}
        >
          View
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          key={2}
          onClick={() => {
            actionCallback(purchaseId, RECEIPT_ACTIONS.EMAIL);
            setOpen(false);
          }}
        >
          Email Receipt
        </MenuItem>
      </Select>
    </div>
  );
};

export default ReceiptActionMenu;
